import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ImagemodalService } from './imagemodal.service';

@Component({
  selector: 'app-imagemodal',
  templateUrl: './imagemodal.component.html',
  styleUrls: ['./imagemodal.component.css']
})
export class ImagemodalComponent implements OnInit {

  imageLink: string;

  constructor(private imageValue : ImagemodalService) {
  
  }

  ngOnInit(): void {
    this.imageValue.imageLink$.subscribe(result => this.imageLink = result);
  }


}
